<template>
  <Card :bordered="false" class="basic-info">
    <p slot="title" class="title">{{ infoFormat.title }}</p>
    <div class="content">
      <Row type="flex">
        <Col v-for="(item,index) in infoFormat.list" :key="index" span="8" class="mb-20">
          <div class="label">
            <span class="add-char"></span>
            <span class="font-gray">{{ item.label }}</span>
          </div>
          <div class="ml-3">{{ item.value || "-" }}</div>
        </Col>
      </Row>
    </div>
  </Card>
</template>
<script>
export default {
  props: {
    infoFormat: {
      type: Object,
      default: () => {
        return {
          title: '',
          list: []
        };
      }
    }
  },
  data() {
    return {

    };
  }
};
</script>
<style lang="scss" scoped>
.basic-info {
  background: #fff;
  border-radius: 10px;
  box-shadow: 2px 2px 4px 2px #e8e8e8;
  margin-bottom: 20px;
  .title {
    padding-left: 8px;
    height: 27px;
    line-height: 27px;
    color: #000;
  }
  .content {
    padding: 14px 138px 10px 24px;
    line-height: 32px;
  }
  .add-char:before {
    content: '*';
    color: red;
    width: 14px;
    height: 32px;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    line-height: 34px;
  }
}
.font-gray {
  color: #a1a1aa;
}
.font-red {
  color: red;
}
.ml-3 {
  margin-left: 12px;
}
.mb-20 {
  margin-bottom: 20px;
}
</style>
